import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import UnitInput from "./unit";
import classnames from "classnames";
import { sameDefaultValueCheck } from "../helpers";
import Responsive from "./responsive";
import ResetState from "./resetstate";
import { GrigoraEditorContext } from "../editor/context";

function MarginInput({
  onCheck,
  value,
  onChange,
  label,
  className,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
  resetValue,
}) {
  const [checked, setChecked] = useState(sameDefaultValueCheck(value));
  const [active, setActive] = useState("desktop");

  const editorContext = useContext(GrigoraEditorContext);

  useEffect(() => {
    if (editorContext?.displaySize && isResponsive) {
      setActive(editorContext.displaySize);
    }
  }, [editorContext?.displaySize]);

  const classes = classnames("mb-4 text-grigora-base", className);

  return (
    <div className={classes}>
      <div className="flex justify-between items-center">
        <div className="flex">
          <h1>{label}</h1>
          {/* {isResponsive && (
            <div className="relative">
              <Responsive
                activeMode={active}
                onChangeActiveMode={(e) => setActive(e)}
              />
            </div>
          )} */}
        </div>
        <div>
          <ResetState
            active={
              value !== resetValue ||
              valueTablet !== resetValueTablet ||
              valueMobile !== resetValueMobile
            }
            onClick={() => {
              onChange(resetValue);
              if (isResponsive) {
                // setActive("desktop");
                setValueTablet(resetValueTablet);
                setValueMobile(resetValueMobile);
              }
            }}
          />
          <button
            className={` p-1 border-none text-grigora-base border text-editor-text-main  `}
            onClick={(e) => setChecked(!checked)}
          >
            {checked ? (
              <FontAwesomeIcon icon={faLock} size="lg" />
            ) : (
              <FontAwesomeIcon icon={faLockOpen} size="lg" />
            )}
          </button>
        </div>
      </div>
      <div>
        <div>
          <UnitInput
            auto
            label="Top"
            isNegativeValid={true}
            value={
              active === "desktop"
                ? value && value.top
                : active === "tablet"
                ? valueTablet && valueTablet.top
                : valueMobile && valueMobile.top
            }
            isResetVisible={false}
            onChange={(e) => {
              if (e !== undefined && e !== null && checked) {
                if (active === "desktop") {
                  onChange({ ...value, top: e, bottom: e, left: e, right: e });
                } else if (active === "tablet") {
                  setValueTablet({
                    ...valueTablet,
                    top: e,
                    bottom: e,
                    left: e,
                    right: e,
                  });
                } else if (active === "mobile") {
                  setValueMobile({
                    ...valueMobile,
                    top: e,
                    bottom: e,
                    left: e,
                    right: e,
                  });
                }
              } else {
                if (active === "desktop") {
                  onChange({ ...value, top: e });
                } else if (active === "tablet") {
                  setValueTablet({
                    ...valueTablet,
                    top: e,
                  });
                } else if (active === "mobile") {
                  setValueMobile({
                    ...valueMobile,
                    top: e,
                  });
                }
              }
            }}
          />
        </div>
        <div className="grigora-margin-mid__container">
          <div className="">
            <UnitInput
              auto
              label="Left"
              isNegativeValid={true}
              value={
                active === "desktop"
                  ? value && value.left
                  : active === "tablet"
                  ? valueTablet && valueTablet.left
                  : valueMobile && valueMobile.left
              }
              isResetVisible={false}
              onChange={(e) => {
                if (e !== undefined && e !== null && checked) {
                  if (active === "desktop") {
                    onChange({
                      ...value,
                      top: e,
                      bottom: e,
                      left: e,
                      right: e,
                    });
                  } else if (active === "tablet") {
                    setValueTablet({
                      ...valueTablet,
                      top: e,
                      bottom: e,
                      left: e,
                      right: e,
                    });
                  } else if (active === "mobile") {
                    setValueMobile({
                      ...valueMobile,
                      top: e,
                      bottom: e,
                      left: e,
                      right: e,
                    });
                  }
                } else {
                  if (active === "desktop") {
                    onChange({ ...value, left: e });
                  } else if (active === "tablet") {
                    setValueTablet({
                      ...valueTablet,
                      left: e,
                    });
                  } else if (active === "mobile") {
                    setValueMobile({
                      ...valueMobile,
                      left: e,
                    });
                  }
                }
              }}
            />
          </div>

          <div className="">
            <UnitInput
              auto
              label="Right"
              isNegativeValid={true}
              value={
                active === "desktop"
                  ? value && value.right
                  : active === "tablet"
                  ? valueTablet && valueTablet.right
                  : valueMobile && valueMobile.right
              }
              isResetVisible={false}
              onChange={(e) => {
                if (e !== undefined && e !== null && checked) {
                  if (active === "desktop") {
                    onChange({
                      ...value,
                      top: e,
                      bottom: e,
                      left: e,
                      right: e,
                    });
                  } else if (active === "tablet") {
                    setValueTablet({
                      ...valueTablet,
                      top: e,
                      bottom: e,
                      left: e,
                      right: e,
                    });
                  } else if (active === "mobile") {
                    setValueMobile({
                      ...valueMobile,
                      top: e,
                      bottom: e,
                      left: e,
                      right: e,
                    });
                  }
                } else {
                  if (active === "desktop") {
                    onChange({ ...value, right: e });
                  } else if (active === "tablet") {
                    setValueTablet({
                      ...valueTablet,
                      right: e,
                    });
                  } else if (active === "mobile") {
                    setValueMobile({
                      ...valueMobile,
                      right: e,
                    });
                  }
                }
              }}
            />
          </div>
        </div>
        <div className="">
          <UnitInput
            auto
            label="Bottom"
            isNegativeValid={true}
            value={
              active === "desktop"
                ? value && value.bottom
                : active === "tablet"
                ? valueTablet && valueTablet.bottom
                : valueMobile && valueMobile.bottom
            }
            isResetVisible={false}
            onChange={(e) => {
              if (e !== undefined && e !== null && checked) {
                if (active === "desktop") {
                  onChange({ ...value, top: e, bottom: e, left: e, right: e });
                } else if (active === "tablet") {
                  setValueTablet({
                    ...valueTablet,
                    top: e,
                    bottom: e,
                    left: e,
                    right: e,
                  });
                } else if (active === "mobile") {
                  setValueMobile({
                    ...valueMobile,
                    top: e,
                    bottom: e,
                    left: e,
                    right: e,
                  });
                }
              } else {
                if (active === "desktop") {
                  onChange({ ...value, bottom: e });
                } else if (active === "tablet") {
                  setValueTablet({
                    ...valueTablet,
                    bottom: e,
                  });
                } else if (active === "mobile") {
                  setValueMobile({
                    ...valueMobile,
                    bottom: e,
                  });
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default MarginInput;
